export const getLanguageFamilyCode = languageCode => languageCode?.split('-')[0];

export const supportedLanguageCodes = {
  spain: 'es-ES',
  peru: 'es-PE',
  colombia: 'es-CO',
  portugal: 'pt',
  italy: 'it',
  france: 'fr',
  uk: 'en'
};

export const availableLanguages = {
  [supportedLanguageCodes.uk]: 'English',
  [supportedLanguageCodes.spain]: 'Español',
  [supportedLanguageCodes.peru]: 'Español(Perú)',
  [supportedLanguageCodes.colombia]: 'Español(Colombia)',
  [supportedLanguageCodes.italy]: 'Italiano',
  [supportedLanguageCodes.portugal]: 'Português',
  [supportedLanguageCodes.france]: 'Français'
};

export const isTranslationAvailable = languageCode => {
  const allLanguageCodes = Object.keys(availableLanguages);
  const isAvailable = allLanguageCodes.includes(languageCode);

  return isAvailable;
};

export const languageCodeOrFallback = languageCode => {
  const languageCodeWithLocalizationSupported = isTranslationAvailable(languageCode);
  if (languageCodeWithLocalizationSupported) {
    return languageCode;
  }
  const familyLanguageCode = getLanguageFamilyCode(languageCode);
  const languageFamilyCodeSupported = isTranslationAvailable(familyLanguageCode);
  if (languageFamilyCodeSupported && familyLanguageCode) {
    return familyLanguageCode;
  }

  return supportedLanguageCodes.spain;
};

export const translationLanguageCodeOrFallback = languageCode => {
  const supportedLanguageCode = languageCodeOrFallback(languageCode);
  if (supportedLanguageCode === supportedLanguageCodes.spain) {
    return getLanguageFamilyCode(supportedLanguageCode);
  }

  return supportedLanguageCode;
};

export const displayFlagCode = fullLangaugeCode => {
  const splittedLanguageCode = fullLangaugeCode?.split('-');
  const languageFlagCode = splittedLanguageCode[splittedLanguageCode.length > 1 ? 1 : 0];

  return languageFlagCode.toLowerCase();
};
